import React, {Component} from 'react';
import RarocHeader from '../../Dashboard/Header/Header';
import './style.scss';
import AssetsCreditRiskTable from './AssetsCreditRiskTable';

export class AssetsCreditRisk extends Component {
  render() {
    return (
      <div className='AssetsCreditRiskcontainer card'>
        <RarocHeader title='TÀI SẢN CÓ RỦI RO TÍN DỤNG' />
        <AssetsCreditRiskTable />
      </div>
    );
  }
}

export default AssetsCreditRisk;



// WEBPACK FOOTER //
// src/pages/Raroc/Report/AssetsCreditRisk/index.js